import React from 'react';

const Section1 = ()=>{

    return(
        <div className="contactUs">
            <div className="row contactWrapper">
               <div className="col-12 heading">
                    Contact Us
               </div>
               <div className="col-12 headingContent">
                   <p>
                        Zunaira Hasan 
                   </p>
                   <p>
                        Manager
                   </p>
                   <p>
                        SDSB Luminites Association
                   </p>
                   <p>
                        Sdsb.luminites@lums.edu.pk
                   </p>
               </div>
               <div className="col-12 heading">
                    Email Address
               </div>
               <div className="col-12 headingContent">
                   <p>
                        Nuzhat Kamran
                   </p>
                   <p>
                        Director – Office of Advancement
                   </p>
                   <p>
                        nuzhat.kamran@lums.edu.pk
                   </p>
               </div>
               <div className="col-12 heading">
                    UAN
               </div>
               <div className="col-12 headingContent">
                   
                   <p>
                        +92 42 3560 8000
                   </p>
               </div>
            </div>
        </div>
    );

}

export default React.memo(Section1);